import { ReactComponent as LockIcon } from 'Components/UI_Library/Icons/Lock.svg';
import './Prism.css';
import { useNavigate } from 'react-router-dom';
import Button from 'Components/UI_Library/FormElements/Button';
import './Prism.css';

const NoAccessSection = (props) => {
    let history = useNavigate();

    return (
        <div className="no-access">
            <div className="no-access-content">
                <LockIcon />
                {props.sentence}
            </div>
            {history && !props.noButton && <Button type="primary-thin" href="/subscribe" text="Upgrade" />}
        </div>
    );
};

export default NoAccessSection;
